/** @jsxImportSource theme-ui */
import React, { ReactNode } from 'react';

import Typography, { VariantLiteral } from 'components/_common/Typography/Typography';

type BdPngExportHeaderProps = {
  title: string | ReactNode;
  superTitle?: string;
  supertitleVariant?: VariantLiteral;
  subTitle?: string;
};

const BdPngExportHeader: React.FC<BdPngExportHeaderProps> = ({
  title,
  superTitle,
  supertitleVariant = 'body2',
  subTitle,
}) => {
  return (
    <div
      sx={{ display: 'flex', py: '32px', justifyContent: 'space-between', alignItems: 'center' }}
    >
      <div>
        {!!superTitle?.length && (
          <Typography variant={supertitleVariant} color="stone70" marginBottom="0">
            {superTitle}
          </Typography>
        )}
        {typeof title === 'string' ? (
          <Typography variant="h4" color="stone90" marginBottom="0px">
            {title}
          </Typography>
        ) : (
          title
        )}
        {!!subTitle?.length && (
          <Typography variant="body2" color="stone70" marginBottom="0">
            {subTitle}
          </Typography>
        )}
      </div>
      <img data-testid="export-bd-logo" src="/bluedot-watermark.svg" alt="bluedot-logo" />
    </div>
  );
};

export default BdPngExportHeader;
